import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class SpinWheelRegionEntity {
  region?: RegionMiniEntity
  districtIds?: Array<number> | null
}